export default function throttle<T extends (...args: any[]) => any>(
  func: T,
  delay: number = 250,
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let lastArgs: Parameters<T> | null = null;
  let lastThis: ThisParameterType<T> | null = null;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    lastArgs = args;
    lastThis = this;

    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        if (lastArgs && lastThis) {
          func.apply(lastThis, lastArgs);
        }
        timeoutId = null;
        lastArgs = null;
        lastThis = null;
      }, delay);
    }
  };
}
